export var OptionType;
(function (OptionType) {
    OptionType["drop_down"] = "drop_down";
    OptionType["color"] = "color";
})(OptionType || (OptionType = {}));
export var ProductType;
(function (ProductType) {
    ProductType["physical"] = "physical";
    ProductType["digital"] = "digital";
})(ProductType || (ProductType = {}));
export var DiscountType;
(function (DiscountType) {
    DiscountType["undefined"] = "UNDEFINED";
    DiscountType["none"] = "NONE";
    DiscountType["amount"] = "AMOUNT";
    DiscountType["percent"] = "PERCENT";
})(DiscountType || (DiscountType = {}));
//# sourceMappingURL=product.dto.js.map